import { mapGetters, mapActions } from "vuex"

var history = {
  computed: {
    ...mapGetters(['history']),
  },
  methods: {
    ...mapActions(['updateTitle']),
  }
}

export default history
